module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture2-f61c06f8ae90c362d769665f3f16eab4.jpg";